// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file guest/v1/availability.proto (package guest.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guest/v1/availability.proto.
 */
export const file_guest_v1_availability: GenFile = /*@__PURE__*/
  fileDesc("ChtndWVzdC92MS9hdmFpbGFiaWxpdHkucHJvdG8SCGd1ZXN0LnYxIlsKGENoZWNrQXZhaWxhYmlsaXR5UmVxdWVzdBIPCgdzaG9wX2lkGAEgASgDEgwKBGRhdGUYAiABKAkSDAoEdGltZRgDIAEoCRISCgpwYXJ0eV9zaXplGAQgASgFIi4KGUNoZWNrQXZhaWxhYmlsaXR5UmVzcG9uc2USEQoJYXZhaWxhYmxlGAEgASgIMnMKE0F2YWlsYWJpbGl0eVNlcnZpY2USXAoRQ2hlY2tBdmFpbGFiaWxpdHkSIi5ndWVzdC52MS5DaGVja0F2YWlsYWJpbGl0eVJlcXVlc3QaIy5ndWVzdC52MS5DaGVja0F2YWlsYWJpbGl0eVJlc3BvbnNlQkdaRWdpdGh1Yi5jb20vZWJpc29sL3ZpYWplcm8vYmFja2VuZC9pbnRlcm5hbC9nZW4vcHJvdG8vZ3Vlc3QvdjE7Z3Vlc3R2MWIGcHJvdG8z");

/**
 * @generated from message guest.v1.CheckAvailabilityRequest
 */
export type CheckAvailabilityRequest = Message<"guest.v1.CheckAvailabilityRequest"> & {
  /**
   * JapanTicket shopId (crud.tc_shop.shop_id。必須)。
   *
   * @generated from field: int64 shop_id = 1;
   */
  shopId: bigint;

  /**
   * 予約希望日 (YYYY-MM-DD 形式。必須)。
   *
   * @generated from field: string date = 2;
   */
  date: string;

  /**
   * 予約希望時刻 (HH:MM 形式。必須)。
   *
   * @generated from field: string time = 3;
   */
  time: string;

  /**
   * 予約人数 (1 以上。必須)。
   *
   * @generated from field: int32 party_size = 4;
   */
  partySize: number;
};

/**
 * Describes the message guest.v1.CheckAvailabilityRequest.
 * Use `create(CheckAvailabilityRequestSchema)` to create a new message.
 */
export const CheckAvailabilityRequestSchema: GenMessage<CheckAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_availability, 0);

/**
 * @generated from message guest.v1.CheckAvailabilityResponse
 */
export type CheckAvailabilityResponse = Message<"guest.v1.CheckAvailabilityResponse"> & {
  /**
   * 指定の日時・人数で空席があるか。
   *
   * @generated from field: bool available = 1;
   */
  available: boolean;
};

/**
 * Describes the message guest.v1.CheckAvailabilityResponse.
 * Use `create(CheckAvailabilityResponseSchema)` to create a new message.
 */
export const CheckAvailabilityResponseSchema: GenMessage<CheckAvailabilityResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_availability, 1);

/**
 * AvailabilityService はゲスト (案件アクセストークン保持者) 向けの店舗空席確認を提供する。
 * 認証は Cognito を通さず、URL 由来の案件アクセストークンを x-case-token ヘッダで受け取り、
 * Guest 公開 Interceptor がハッシュ照合して案件・テナントを解決する (ADR-011 /
 * ゲストアプリの設計 §4・§5)。トークン不一致・失効は NotFound、期限切れは FailedPrecondition。
 *
 * @generated from service guest.v1.AvailabilityService
 */
export const AvailabilityService: GenService<{
  /**
   * CheckAvailability は指定した店舗・日時・人数で予約サイトの空席を確認する (JPTP_CANSEI-1356)。
   * Backend は crud.tc_shop の店舗ログイン情報を復号し、予約サイト操作 Bot (Lambda) を同期
   * Invoke して空席の有無を返す。滞在時間は Backend 固定値 (120 分) を用いる。
   * 個室希望は request に持たせず、案件アクセストークンで解決した案件に Concierge が保存した
   * 現在値 (extracted_conditions.private_room_requested) を Backend が読んで候補席の絞り込みに使う
   * (JPTP_CANSEI-1607)。ゲスト側からは指定・変更できない。
   * 「空席なし」は正常応答 (available=false) であり、Bot の操作失敗・判定不能はエラーで返す。
   *
   * @generated from rpc guest.v1.AvailabilityService.CheckAvailability
   */
  checkAvailability: {
    methodKind: "unary";
    input: typeof CheckAvailabilityRequestSchema;
    output: typeof CheckAvailabilityResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guest_v1_availability, 0);

